<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" vislbleAlert />

    <!--    요청자 구분-->
    <div class="mt-7">
      <h5><i class="dot"></i> 요청자 구분</h5>
      <div class="grid grid-cols-8 gap-y-4 mt-5">
        <fragment v-if="!isPrint">
          <vs-radio v-for="_type in ['사업주', '근로자', '기타']" :key="_type" v-model="form.요청자구분" :vs-value="_type">{{ _type }}</vs-radio>
        </fragment>
        <fragment v-else>
          <PrintRadio v-for="_type in ['사업주', '근로자', '기타']" :key="`print_${_type}`" :value="form.요청자구분 === _type" :label="_type" class="justify-center" />
        </fragment>
      </div>
    </div>

    <!-- 부가정보 : 작업중지 및 사용중지 현황-->
    <write-grid-container title="작업중지 및 사용중지 현황" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-textarea" v-if="dataType === 'textarea'">{{ form.subInfo[value] }}</div>
          <div v-else-if="dataType === 'datetime'" class="flex items-center gap-2">
            <div class="print-input">{{ form.subInfo[value].date }}</div>
            <div class="print-input">{{ form.subInfo[value].time }}</div>
          </div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <disaster-class-selector v-else-if="dataType === 'disaster'" class="w-full" v-model="form.subInfo[value]" />
          <ml-textarea v-else-if="dataType === 'textarea'" class="w-full" rows="5" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'datetime'" class="w-full flex items-center gap-2">
            <date-selector class="w-full" v-model="form.subInfo[value].date" />
            <time-selector class="w-full" v-model="form.subInfo[value].time" />
          </div>
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 조치 전 사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList1" :is-print="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="사진 설명" class="page-break" />

    <!-- 부가정보 : 조치 현황-->
    <write-grid-container title="조치 현황" v-model="form.subInfo2" :options="gridContainerOptions2" class="page-break mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo2[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo2[value]" />
          <custom-option-selector v-else-if="dataType === 'selector'" class="w-full" v-model="form.subInfo2[value]" :options="result_options" />
          <ml-input v-else class="w-full" v-model="form.subInfo2[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 조치 전 사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList2" :is-print="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="사진 설명" class="page-break" />

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import { required } from "vuelidate/lib/validators";

import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";

export default {
  components: {
    FileUploader,
    CustomOptionSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
    DateSelector,
    DisasterClassSelector,
    PhotoUploadGridModule,
    TimeSelector,
    PrintRadio,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      result_options: ["조치 전", "조치 중", "조치 완료", "기타"],
      gridContainerOptions: {
        classes: ["", "", "", "", "", "", "writeGridLineItem", ""],
        dataTypes: ["string", "string", "string", "string", "string", "disaster", "textarea", "datetime", "string"],
        labels: ["작업명", "소속명", "부서명", "요청자", "중지대상", "재해형태", "중지사유", "요청일시", "작업장소"],
        values: ["작업명", "소속명", "부서명", "요청자", "중지대상", "재해형태", "중지사유", "요청일시", "작업장소"],
      },
      gridContainerOptions2: {
        dataTypes: ["string", "string", "string", "string", "selector", "date"],
        labels: ["소속명", "부서명", "조치자", "조치내용", "조치 현황", "조치 완료일"],
        values: ["소속명", "부서명", "조치자", "조치내용", "조치현황", "조치완료일"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        subInfo2: {},

        photoList1: [],
        photoList2: [],

        요청자구분: "",
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.subInfo": {
      immediate: true,
      deep: true,
      handler(value) {
        // 기존에 요청일을 요청일시로 변경
        // 요청일시가 없으면 요청일을 date로 설정
        if (!value.요청일시) {
          this.$set(this.form.subInfo, '요청일시', { date: '', time: '' });

          if (value.요청일 && typeof value.요청일 === 'string') {
            this.$set(this.form.subInfo, '요청일시', { date: value.요청일, time: '' });
          }
        }
      },
    }
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur, index) => {
      // datetime 타입인 경우 객체로 초기화
      if (this.gridContainerOptions.dataTypes[index] === 'datetime') {
        acc[cur] = { date: '', time: '' };
      } else {
        acc[cur] = "";
      }
      return acc;
    }, {});
    this.form.subInfo2 = this.gridContainerOptions2.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
